import React, { useCallback, useMemo, useState } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { useHistory } from 'react-router-dom';
import { Popconfirm, Row, Table, Tag, Tooltip } from 'antd';
import {
  GoogleMap,
  useJsApiLoader,
  Polygon,
  Marker,
  Polyline,
} from '@react-google-maps/api';
import { MapTrifold, Trash } from 'phosphor-react';

import ENV from 'config';
import style from '../style.module.css';
import { ReactComponent as IconCerca } from '../../../../imgs/cerca-eletronica.svg';
import { googleLibraries } from 'utils/functionsUtils';
import { FILE_TYPE_SUPESP } from 'utils/reutils';
import { FenceSupespUpload } from 'interfaces/statistics';
import ICON_CVLI from '../../../../imgs/violent_crime.svg';

const containerStyle = {
  width: '100%',
  height: '100%',
  borderRadius: 12,
};

type TCardCerca = {
  id: string;
  nome: string;
  deleteItem?: (id: string, nome: string) => void;
  feature: FenceSupespUpload;
  tipo: typeof FILE_TYPE_SUPESP[number];
  system: boolean;
};

const COLORS_BY_TYPE: { [key: typeof FILE_TYPE_SUPESP[number]]: string } = {
  CERCA: 'green',
  ACE: 'geekblue',
  QUADRA: 'volcano',
  CVLI: 'purple',
};

export default function CardUploadedItem({
  id,
  nome,
  deleteItem,
  feature,
  tipo,
  system,
}: TCardCerca) {
  const [isModalMapVisible, setIsModalMapVisible] = useState(false);

  const history = useHistory();

  const mapOptions = {
    // styles: [
    //   {
    //     elementType: 'labels',
    //     featureType: 'poi',
    //     stylers: [{ visibility: 'on' }],
    //   },
    // ],
    mapId: ENV.mapId,
    panControl: true,
    panControlOptions: {
      position: 4,
    },
    mapTypeControl: true,
    fullscreenControl: false,
    zoomControl: false,
    streetViewControl: true,
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: ENV.googleMapsApiKey,
    libraries: googleLibraries,
    region: 'BR',
    language: 'pt-br',
  });

  const getCentroid = useCallback((arr: any) => {
    return arr.reduce(
      (x: any, y: any) => {
        return [x[0] + y[0] / arr.length, x[1] + y[1] / arr.length];
      },
      [0, 0]
    );
  }, []);

  const pathsFormatted = useMemo(() => {
    const targets = feature.points;

    let locations: any = [];
    targets.map((target: any) => {
      let obj = {
        lat: target[0],
        lng: target[1],
      };
      locations.push(obj);
    });
    return locations;
  }, []);

  return (
    <div key={id} className={style.collabsible}>
      <input id={id} className={style.toggle} type="checkbox" />
      <label htmlFor={id} className={style.lblToggle}>
        <div className={style.rowCollum}>
          <Row>
            <IconCerca className={style.rowTitleIcon} />
            <div className={style.rowTitle}>
              {nome}
              {' - '}
              {feature.cidade}
            </div>
            <Tag
              className={style.hide}
              style={{ marginLeft: '10px', padding: '3px', fontSize: '14px' }}
              color={COLORS_BY_TYPE[tipo] || 'green'}
              key="tag"
            >
              {tipo}
            </Tag>
          </Row>
        </div>
        <div className={style.rowCollum}>
          <Row>
            <Tooltip key="mapButton" title="Mapa">
              <button
                type="button"
                className={style.buttonG}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsModalMapVisible(true);
                }}
              >
                <MapTrifold
                  color="#18A779"
                  size={32}
                  className={style.cercasIcon}
                />
              </button>
            </Tooltip>
            {!system && (
              <div className={style.adminButtons}>
                {deleteItem && (
                  <Tooltip title="Excluir" color="red">
                    <Popconfirm
                      placement="top"
                      title={'Deseja realmente excluir?'}
                      onConfirm={() => deleteItem(id, nome)}
                      okText="Ok"
                      cancelText="Cancelar"
                    >
                      <button type="button" className={style.buttonG}></button>
                      <Trash
                        color="#E93F32"
                        size={32}
                        className={style.cercasIcon}
                      />
                    </Popconfirm>
                  </Tooltip>
                )}
              </div>
            )}
          </Row>
        </div>
      </label>
      <Modal
        destroyOnClose
        onCancel={() => {
          setIsModalMapVisible(false);
        }}
        open={isModalMapVisible}
        footer={null}
      >
        <div style={{ height: 500 }}>
          <h1>Visualização</h1>
          <div style={{ width: 470, height: 450 }}>
            {isLoaded && (
              <GoogleMap
                id={ENV.mapId}
                mapContainerStyle={containerStyle}
                center={{
                  lat: getCentroid(feature.points)[0],
                  lng: getCentroid(feature.points)[1],
                }}
                zoom={10}
                options={mapOptions}
              >
                {tipo === 'QUADRA' ? (
                  <Polyline path={pathsFormatted} />
                ) : tipo === 'CVLI' ? (
                  <Marker
                    icon={{
                      url: ICON_CVLI,
                      scaledSize: new window.google.maps.Size(17, 20),
                    }}
                    position={pathsFormatted[0]}
                  />
                ) : (
                  <Polygon paths={pathsFormatted} />
                )}
              </GoogleMap>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
